export const ledgerStatementHeaders = [
  {
    text: "Date",
    value: "date"
  },
  {
    text: "Type",
    value: "type"
  },
  {
    text: "Description",
    value: "description"
  },
  {
    text: "Amount",
    value: "amount"
  },
  {
    text: "Tax",
    value: "tax"
  }
];
